import React from 'react';
import { Link } from 'react-router-dom';

const ContentHeader = ({ location }) => {
  const getPageInfo = (pathname) => {
    const routes = {
      '/': { title: 'Dashboard', breadcrumb: ['Home', 'Accounting Reports'] },
      '/cms': { title: 'CMS Overview', breadcrumb: ['Home', 'CMS', 'Overview'] },
      '/cms/pages': { title: 'CMS Pages', breadcrumb: ['Home', 'CMS', 'Pages'] },
      '/cms/content': { title: 'CMS Content', breadcrumb: ['Home', 'CMS', 'Content'] },
      '/cms/products': { title: 'Products', breadcrumb: ['Home', 'CMS', 'Products'] },
      '/cms/products/create': { title: 'Create Product', breadcrumb: ['Home', 'CMS', 'Products', 'Create'] },
      '/cms/categories': { title: 'Categories', breadcrumb: ['Home', 'CMS', 'Categories'] },
      '/cms/brands': { title: 'Brands', breadcrumb: ['Home', 'CMS', 'Brands'] },
      '/cms/orders': { title: 'Orders', breadcrumb: ['Home', 'CMS', 'Orders'] },
      '/licenses': { title: 'Licenses', breadcrumb: ['Home', 'Licenses'] },
      '/licenses/tiers': { title: 'License Tiers', breadcrumb: ['Home', 'Licenses', 'Tiers'] },
      '/licenses/create': { title: 'Create License', breadcrumb: ['Home', 'Licenses', 'Create'] },
      '/licenses/plan-requests': { title: 'Plan Selection Requests', breadcrumb: ['Home', 'Licenses', 'Plan Requests'] },
    };

    if (pathname.startsWith('/licenses/edit/')) {
      return { title: 'Edit License', breadcrumb: ['Home', 'Licenses', 'Edit'] };
    }
    if (pathname.startsWith('/cms/products/edit/')) {
      return { title: 'Edit Product', breadcrumb: ['Home', 'CMS', 'Products', 'Edit'] };
    }
    if (pathname.startsWith('/cms/orders/') && pathname !== '/cms/orders') {
      return { title: 'Order Details', breadcrumb: ['Home', 'CMS', 'Orders', 'Details'] };
    }

    return routes[pathname] || { title: 'Dashboard', breadcrumb: ['Home', 'Dashboard'] };
  };

  const pageInfo = getPageInfo(location.pathname);

  return (
    <div className="content-header">
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-sm-6">
            <h1 className="m-0">{pageInfo.title}</h1>
          </div>
          <div className="col-sm-6">
            <ol className="breadcrumb float-sm-right">
              {pageInfo.breadcrumb.map((item, index) => (
                <li key={index} className={`breadcrumb-item ${index === pageInfo.breadcrumb.length - 1 ? 'active' : ''}`}>
                  {index === 0 ? <Link to="/">{item}</Link> : item}
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContentHeader;


